export function getFileNameFromPath(filePath: string): string {
  if (!filePath) return '';
  const normalized = filePath.replace(/\\/g, '/');
  const parts = normalized.split('/');
  const last = parts[parts.length - 1];
  return last || filePath;
}

/**
 * Fast, stable 32-bit FNV-1a hash for dirty tracking.
 * Returns an unsigned hash encoded as base36 for compact storage.
 */
export function hashText(text: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(36);
}

export function isFileOutOfDate(args: { query: string; fileLastSavedHash?: string }): boolean {
  if (!args.fileLastSavedHash) return false;
  return hashText(args.query) !== args.fileLastSavedHash;
}

